<template>
    <modal
        :adaptive="true"
        :clickToClose="false"
        :maxWidth="575"
        :pivotY="pivotY"
        :reset="true"
        :scrollable="true"
        height="auto"
        name="age-verification-modal"
        width="575"
    >
        <div class="item-modal-content relative flex flex-col w-full">
            <img
                v-if="isChallenge25"
                alt="Challenge 25"
                src="https://ucarecdn.com/cb736099-5809-4808-8d12-95cf87d538bc/-/format/auto/-/resize/1200x/"
            />
            <div
                v-else
                class="item-modal-details flex-auto p-8 overflow-y-auto"
            >
                <div>
                    <h4 class="pb-1 text-gray-800 text-xl font-bold">
                        {{ ageVerificationTitle }}
                    </h4>
                    <p class="text-gray-600 leading-relaxed"> </p>
                </div>
            </div>
            <div
                class="item-modal-footer flex flex-col-reverse items-start justify-between p-10 md:flex-row"
            >
                <button
                    class="flex-auto p-3 px-10 w-full text-center text-red-900 text-sm font-bold rounded-sm md:w-1/2"
                    @click="underAge()"
                >
                    {{ underAgeButtonText }}
                </button>
                <button
                    class="flex-auto mb-3 p-3 px-12 w-full text-center text-white text-sm font-bold bg-button font-button clip-path-button rounded-button rounded-sm md:mb-0 md:ml-3 md:w-1/2"
                    @click="confirmAgeOver18()"
                >
                    {{ overAgeButtonText }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapMutations } from 'vuex';
import { AgeGateEnum } from '@/enums';
import isMobile from '@/helpers/isMobileDevice';

export default {
    name: 'age-verification-modal',
    data() {
        return {
            isLoading: false
        };
    },
    computed: {
        pivotY() {
            return isMobile() ? 1 : 0.5;
        },
        isChallenge25() {
            return (
                this.$store.state.venue?.venue?.ageGated ===
                AgeGateEnum.UK_CHALLENGE_25
            );
        },
        isUSOver21() {
            return (
                this.$store.state.venue?.venue?.ageGated ===
                AgeGateEnum.US_OVER_21
            );
        },
        ageVerificationTitle() {
            if (this.isUSOver21) {
                return this.$t('ageVerificationModal.mustBeOver21');
            }
            return this.$t('ageVerificationModal.mustBeOver18');
        },
        underAgeButtonText() {
            if (this.isUSOver21) {
                return this.$t('ageVerificationModal.under21');
            }
            return this.$t('ageVerificationModal.under18');
        },
        overAgeButtonText() {
            if (this.isUSOver21) {
                return this.$t('ageVerificationModal.over21');
            }
            return this.$t('ageVerificationModal.over18');
        }
    },
    methods: {
        ...mapMutations({
            setAgeOver18Confirmed: 'cart/SET_AGE_OVER_18_CONFIRMED'
        }),
        confirmAgeOver18() {
            this.setAgeOver18Confirmed(true);
            this.$modal.hide('age-verification-modal');
        },
        underAge() {
            this.$modal.hide('item-modal');
            this.$modal.hide('age-verification-modal');
        }
    }
};
</script>
